var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"card",staticClass:"cpt-chat-hover-card rounded-[8px] pointer"},[_c('div',{staticClass:"hover-card relative wh-full overflow-hidden"},[_vm._t("default")],2),_vm._t("tag")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }